"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var inversify_config_1 = require("./inversify.config");
var TypeDefs_1 = require("./TypeDefs");
var I18nProvider_1 = require("./I18nProvider");
var CoreApp = /** @class */ (function () {
    function CoreApp() {
        /**
         * List of loaded plugins
         */
        this.pluginDefinitions = [];
    }
    /**
     * Get extension points
     */
    CoreApp.prototype.getExtensionPoints = function () {
        var extensionPoints = {
            menu: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.MenuManager),
            navbar: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.NavBarManager),
            routes: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.RoutesManager),
            widgets: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.WidgetsManager),
            commands: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.CommandManager),
            i18n: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.I18nManager),
            journeyComponents: inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.JourneyComponentsManager),
            services: inversify_config_1.iocContainer
        };
        return extensionPoints;
    };
    /**
     * Register plugin for the app
     * @param pluginDefinition
     */
    CoreApp.prototype.registerPlugin = function (pluginDefinition) {
        pluginDefinition.plugin.register(this.getExtensionPoints(), pluginDefinition.configuration);
        this.pluginDefinitions.push(pluginDefinition);
    };
    /**
     * Set theme variables
     * @param theme Theme variable definitions
     */
    CoreApp.prototype.setTheme = function (theme) {
        inversify_config_1.iocContainer.bind(TypeDefs_1.TypeDefs.ThemeVars).toConstantValue(theme);
    };
    /**
     * Getter for i18n manager
     */
    CoreApp.prototype.i18n = function () {
        return inversify_config_1.iocContainer.get(TypeDefs_1.TypeDefs.I18nManager);
    };
    /**
     * Register IoC service
     */
    CoreApp.prototype.registerService = function (type, service) {
        return inversify_config_1.iocContainer
            .bind(type)
            .to(service);
    };
    /**
     * Register list of plugins
     * @param pluginDefinitions
     */
    CoreApp.prototype.registerPlugins = function () {
        var _this = this;
        var pluginDefinitions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pluginDefinitions[_i] = arguments[_i];
        }
        pluginDefinitions.forEach(function (pluginDefinition) { return _this.registerPlugin(pluginDefinition); });
    };
    /**
     * Renders the application
     * @param layout
     * @param container
     */
    CoreApp.prototype.render = function (layout, container) {
        ReactDOM.render(React.createElement(I18nProvider_1.I18nProvider, null,
            React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement(React.Fragment, null, layout))), container);
    };
    return CoreApp;
}());
exports.default = CoreApp;
//# sourceMappingURL=CoreApp.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/CoreApp.js
// module id = 2041
// module chunks = 0